module.exports = __webpack_public_path__ + "static/GT-Walsheim-Regular-a73b1b260180f616b35c08fddef8b46e.woff";